import React from 'react';
import ReturnsIcon from '../../../common/icons/ReturnsIcon';
import { RETURNS_ROUTE } from '../../../../constants/Routes';

export const returnsGroup = [
  {
    route: RETURNS_ROUTE,
    icon: <ReturnsIcon size="30px" />,
    title: 'Devoluciones',
    id: 'returnsSection',
  },
];
